module.exports = __webpack_public_path__ + "img/keypad.ddb2ebd8.svg";